/* AsyncCommand superclass
 * extends: AbstractCommand
 * methods:
 *  - cancel: allow prevent proceeding command and clear listeners stack
 *  - registerCompleteCallback: registers a complete callback
 *  - dispatchComplete(success): call complete callbacks and let know the command status; is to be called inside 'execute' implementation
 */

define(["./AbstractCommand", "createjs"], function(AbstractCommand)
{

    function AsyncCommand()
    {
        this.done = false;
        this.AbstractCommand_constructor();
    }
    var c = AsyncCommand;
    createjs.extend(c, AbstractCommand);
    var p = c.prototype;


    p.execute = function()
    {
        this.canceled = false;
        this.done = false;
        this.AbstractCommand_execute.apply(this);
    };

    p.undo = function()
    {
        this.cancel();
        this.AbstractCommand_undo.apply(this);
    };

    p.cancelable = true;
    p.canceled = false;
    p.cancel = function()
    {
        this.removeListeners();
    };

    p.registerCompleteCallback = function(listener, listenerObject)
    {
        if (!this.listeners)
        {
            this.listeners = [];
            this.listenerObjects = [];
        }
        this.listeners.push(listener);
        this.listenerObjects.push(typeof listenerObject !== "undefined" ? listenerObject : null);
    }

    p.dispatchComplete = function(success)
    {
        if (this.canceled || this.done) return;
        if (!this.listeners) return;
        var listener;
        var i = 0;

        this.done = true;
        while (!this.canceled && this.listeners && i < this.listeners.length)
        {
            listener = this.listeners[i];
            listener.apply(this.listenerObjects[i] || this, [success]);
            i++;
        }

        if (!this.reusable)
            this.removeListeners();
    }

    p.removeListeners = function()
    {
        if (this.listeners)
        {
            this.listeners.splice(0, this.listeners.length);
            this.listenerObjects.splice(0, this.listenerObjects.length);
            this.listeners = null;
            this.listenerObjects = null;
        }
    }

    p.popListener = function () {
        return {listener: this.listeners.pop(), target: this.listenerObjects.pop()};
    }

    createjs.promote(c, "AbstractCommand");

    return c;
});


// WEBPACK FOOTER //
// ./js/rrjs/base/commands/AsyncCommand.js